import React from 'react';
import {ReactComponent as Icon} from './lock_icon_new1_filled.svg';

export const LockIcon = () => <Icon/>;